import styled from 'styled-components';
import { IconButton } from '@material-ui/core';

export const InfoAreaContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 14px;
`;

export const InfoArea = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(33.33% - 11px);
  @media (max-width: 1200px) {
    width: calc(50% - 8px);
  }
  @media (max-width: 750px) {
    width: 100%;
  }
`;

export const InfoAreaTitle = styled.h3`
  padding: 10px 10px 8px 10px;
`;

export const InfoAreaButton = styled(IconButton)`
  float: right;
  margin-top: -12px;
  margin-bottom: -20px;
  margin-right: -12px;
`;
